import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import CategoryComponent from "./CategoryComponent";
import { Box, Typography, Divider } from "@mui/material";
import News from "./News";
import { useStyles } from "./Aside.styles";

// External covide APIs

const newsAPI =
  "https://gnews.io/api/v4/search?q=ukraine&token=f087cfb59cf0dd75a3b52ca349725dbe&lang=en&max=10?topic=breaking-news";

const Aside = () => {
  const [news, setNews] = useState([]);
  const classes = useStyles();

  const fetchNews = useCallback(async () => {
    try {
      let { data } = await axios.get(newsAPI);
      if (data) {
        data.articles = [
          ...new Map(
            data.articles.map((article) => [article.title, article])
          ).values(),
        ];
        setNews(data.articles);
      }
    } catch (err) {
      console.log(err);
    }
  }, []);

  useEffect(() => {
    fetchNews();
  }, [fetchNews]);

  return (
    <Box className={classes.root}>
      {/* Categories from Server */}
      <CategoryComponent />
      {/* Quotes */}
      <div>
        <Typography component="h2">Aphorism </Typography>
        <p style={{ lineHeight: 2, color: "#999", fontStyle: "italic" }}>
          „ბოროტებას უყვარს პატიოსნება. უფრო სწორად, უყვარს პატიოსნების ნიღაბი.
          ამ ნიღბით იგი უფრო იოლად აკეთებს ავსა და უკეთურ საქმეს. მოხერხებულად
          აყრის საზოგადოებას თვალში ნაცარს. პატიოსნებას მიტმასნებული ბოროტების
          წინააღმდეგ ბრძოლა ძნელია. ადამიანს უჭირს გაარჩიოს, სად არის ხალასი
          პატიოსნება და სად – რიოში, ყალბი.“
        </p>
        <p style={{ color: "#777", fontStyle: "italic" }}> - აკაკი ბაქრაძე</p>
      </div>
      {/* News */}
      <div>
        <Typography component="h2" gutterBottom>
          Top news from Ukraine
        </Typography>
        <div className="hr_line"></div>

        {news.length > 0 ? (
          <News news={news} />
        ) : (
          <Typography variant="caption">Currently unavailable</Typography>
        )}
      </div>
    </Box>
  );
};

export default Aside;
